import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "./env";

// Type "loose" volontairement : le typage strict Database cassait les chaînes
// .update({...}) et .insert({...}) dans les composants. Les hooks/pages typent
// explicitement leurs retours via select<...>() côté caller.
export const supabase: SupabaseClient = createClient(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: "super-pari-auth",
    },
    global: { headers: { "x-client-info": "super-pari-web" } },
  }
);

export async function callFunction<T = unknown>(
  name: string,
  body?: Record<string, unknown>
): Promise<T> {
  const { data, error } = await supabase.functions.invoke<T>(name, { body });
  if (error) throw error;
  if (!data) throw new Error("Empty response");
  return data as T;
}
